<button class="context-button" mat-menu-item [title]="data.title | translate"
  (click)="handleAction(data.action);">
  <img *ngIf="data.image; else icon" [src]="data.icon" class="adf-icon mat-icon">
  <ng-template #icon>
    <mat-icon *ngIf="!data.icon.startsWith('adf:'); else adfIcon">{{ data.icon }}</mat-icon>
    <ng-template #adfIcon>
      <adf-icon [value]="data.icon"></adf-icon>
    </ng-template>
  </ng-template>
  <span class="menuAction">{{ data.title | translate }}</span>
</button>